import React, { Component } from "react";
import "./RecommendedItineraries.css";
import { RecommendedItinerariesItem } from "./RecommendedItinerariesItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";

class RecommendedItineraries extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.RecommendedItinerariesSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.RecommendedItineraries = [
      {
        id: "1",
        title: "Why Israel",
        daysTitle: "",
        img: "RecommendedItinerariesMice/Why_Israel.jpg",
        link: "/Posts/itineraries/Why_Israel",
      },
      {
        id: "2",
        title: "Marketing Cooperation Agreement",
        daysTitle: "",
        img: "RecommendedItinerariesMice/Marketing_Cooperation_Agreement.jpg",
        link: "/Posts/itineraries/Marketing_Cooperation_Agreement",
      },
      {
        id: "3",
        title: "The Industrial Cooperation Authority",
        daysTitle: "",
        img:
          "RecommendedItinerariesMice/The_Industrial_Cooperation_Authority.jpg",
        link: "/Posts/itineraries/The_Industrial_Cooperation_Authority",
      },
    ];
  }

  render() {
    const RecommendedItinerariesHtml = this.RecommendedItineraries.map((o) => {
      return (
        <RecommendedItinerariesItem
          title={o.title}
          daysTitle={o.daysTitle}
          img={o.img}
          link={o.link}
          key={o.id}
          id={o.id}
        />
      );
    });
    return (
      <div className="recommended-itineraries-wrapper">
        <SimpleSlider settings={this.RecommendedItinerariesSliderSettings}>
          {RecommendedItinerariesHtml}
        </SimpleSlider>
      </div>
    );
  }
}

export default RecommendedItineraries;



// WEBPACK FOOTER //
// ./src/Components/RecommendedItineraries/RecommendedItinerariesMice.js